<template>
  <div class="page_container">
    <router-view />
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Layout",
  data() {
    return {};
  },
  methods: {
    ...mapActions("app", ["setUserInfo"]),
  },
  mounted() {
    window.setUserInfo = (res) => {
      var data = JSON.parse(res);
      let memberInfo = data.memberInfo;
      _this.setUserInfo(memberInfo);
    }
  },
};
</script>
<style lang="scss" scoped>
.page_container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>